module.exports = __webpack_public_path__ + "static/media/connection-lost.c9402d49.png";